const groupImage = (group) => (
  group?.image_medium
  || group?.image
  || group?.image_object?.image_webp
  || group?.image_object?.image
  || null
);

const groupUrl = (group) => {
  if (group?.url) return group.url;
  if (group?.slug) return `/shop/${group.slug}/`;
  return '#';
};

export default function GroupCard({ group }) {
  if (!group) return null;
  const name = group.name || group.translated__name || '';
  const image = groupImage(group);
  const url = groupUrl(group);
  return (
    <a className="product-card featured-group-card text-decoration-none text-dark" href={url}>
      <div className="product-card-inner d-flex flex-column align-items-center justify-content-center h-100 bg-white border rounded-4 p-3">
        {image ? (
          <img
            alt={name}
            src={image}
            className="mb-3"
            style={{ width: '100%', maxWidth: 110, maxHeight: 90, objectFit: 'contain' }}
          />
        ) : null}
        <h3 className="h6 text-center mb-0">{name}</h3>
      </div>
    </a>
  );
}
